{
  "View": "Ver",
  "fullProfile": "s perfil completo ",
  "ProfilePhrase1": "Conoce a miles de personas que desarollan y promueven sus proyectos e innovaciones en RebelBase.",
  "signUpFree": "Regístrate gratis",
  "or": "o",
  "Login": "Iniciar sesión",
  "Projects": "Proyectos",
  "loading": "Cargando...",
  "NoProjects": "Sin proyectos",
  "Boohoo": "Boohoo ... ¡Todavía no tienes un proyecto!",
  "CreateProject": "Crear un nuevo proyecto",
  "Project": "Proyecto",
  "CreateNewProject": "Crear un nuevo proyecto",
  "save": "Guardar",
  "SocialLinks": "Redes sociales",
  "ProfilePhrase2": "Socialízate. Agrega redes sociales para que te contacten.",
  "AddSocialLinks": "Añadir redes sociales",
  "Connect": "Conectar",
  "linkedinUsername": "Usuario de Linkedin",
  "twitterHandle": "Usuario de Twitter",
  "facebookUsername": "Usuario de Facebook",
  "About": "Acerca de",
  "ProfilePhrase3": "Parece estar bastante vacio...",
  "NoAbout": "De momento sigue vacio",
  "ProfilePhrase4": "Cuéntanos un poco sobre ti. Recomendamos que compartas tus pasiones y especialidades. Si estás atascado, responde dos de estas preguntas: ¿Cuál es tu misión en la vida? ¿Que te preocupa? ¿Cuándo trabajas mejor? ¿Qué te ha preparado en el pasado para tus objetivos?",
  "updatePic": "Actualizar foto",
  "ProfilePhrase5": "Las experiencias le informan a la gente sobre lo que has hecho y ayudará a otros a descubrir tus proyectos.",
  "NoExperience": "Sin experiencia intruducida todavia",
  "JudgeBio": "Biografia de juez para eventos",
  "whoAreYou": "¿Quien eres?",
  "EditBio": "Edita tu biografia",
  "NoJudgeBio": "Sin biografia de juez todavia.",
  "Title": "Título",
  "JudgeBioPhrase": "Cuéntales a los asistentes al evento sobre ti. Te recomendamos que compartas tus logros recientes y tus pasiones.",
  "Delete": "Eliminar",
  "Experience": "Experiencia",
  "StartDate": "Fecha de inicio",
  "EndDate": "Fecha final",
  "Present": "Presente",
  "ExperienceTitle": "Título de la experiencia",
  "CompanyOrSchool": "Empresa o institucion",
  "AffiliatedCompanyOrSchool": "Nombre de la empresa, universidad, escuela,...",
  "Description": "Descripción",
  "ShortDescription": "Breve descripción de la experiencia",
  "on": "Activado",
  "off": "Desactivado",
  "PublicVisibility": "Perfil público",
  "whoCanSee": "(solo tu puedes ver esto)",
  "EditVisibility": "Editar visibilidad",
  "NotLoggedinView": "Visualizadores que no estan registrados verán:",
  "ifOn": " tú en búsqueda y todo tu perfil.",
  "ifOff": " solo información básica (nombre, propósito, foto de perfil y proyectos a los que formas parte).",
  "Completed": "Completado",

  "Add": "Añadir",
  "Edit": "Editar"
}
